import React from "react";
import { Grid } from "@mui/material";
import Slider from "react-slick";
import { getAssets } from "@unisearch/helpers";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import styles from "./technology_success.module.scss";

export const ElearningTechnologySuccess = () => {
  const settings = {
    dots: true,
    arrows: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 900,
        settings: {
          arrows: false,
          centerMode: false,
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  return (
    <section className={styles.section_technology}>
      <div className="container">
        <div className={styles.heading_wrapper}>
          <h2 className={styles.heading}>
            Technology Built for{" "}
            <span className={`color-orange`}>Your Success</span>
          </h2>
          <p>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Dictum nunc
            donec vulputate ut in sapien nunc, sit. Amet, viverra arcu est,
            imperdiet. Porta sollicitudin tempus odio gravida eget.
          </p>
        </div>

        <div className="elearning_exam_success_slider">
          <Slider {...settings}>
            <div className={styles.success_slider_wrapper}>
              <Grid container spacing={{ xs: 2, sm: 2, md: 4 }}>
                <Grid item xs={12} sm={12} md={6}>
                  <div className={styles.image_wrapper}>
                    <img
                      src={getAssets(
                        "assets/images/elearning/home/laptop-mockup.png"
                      )}
                      alt="laptop-mockup"
                    />
                  </div>
                </Grid>
                <Grid item xs={12} sm={12} md={6}>
                  <div className={styles.description_wrapper}>
                    <h3 className={styles.description_heading}>
                      Secure and Robust
                    </h3>
                    <div className={styles.description}>
                      <p>
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                        Ac massa enim id tincidunt eget vitae. Consequat egestas
                        amet, elit eu. Egestas placerat laoreet varius risus,
                        mauris vitae dui, amet. Nulla quam porttitor non
                        consequat, pulvinar.
                      </p>
                      <p>
                        Eu odio nam convallis velit enim volutpat. Ipsum quis
                        pulvinar vitae bibendum gravida maecenas fusce etiam.
                        Scelerisque sit nunc, praesent blandit risus. Tortor
                        vulputate nibh ipsum amet, nam turpis volutpat facilisis
                        ornare. Orci.
                      </p>
                    </div>
                  </div>
                </Grid>
              </Grid>
            </div>
            <div className={styles.success_slider_wrapper}>
              <Grid container spacing={{ xs: 2, sm: 2, md: 4 }}>
                <Grid item xs={12} sm={12} md={6}>
                  <div className={styles.image_wrapper}>
                    <img
                      src={getAssets(
                        "assets/images/elearning/home/laptop-mockup.png"
                      )}
                      alt="laptop-mockup"
                    />
                  </div>
                </Grid>
                <Grid item xs={12} sm={12} md={6}>
                  <div className={styles.description_wrapper}>
                    <h3 className={styles.description_heading}>
                      Secure and Robust
                    </h3>
                    <div className={styles.description}>
                      <p>
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                        Ac massa enim id tincidunt eget vitae. Consequat egestas
                        amet, elit eu. Egestas placerat laoreet varius risus,
                        mauris vitae dui, amet. Nulla quam porttitor non
                        consequat, pulvinar.
                      </p>
                      <p>
                        Eu odio nam convallis velit enim volutpat. Ipsum quis
                        pulvinar vitae bibendum gravida maecenas fusce etiam.
                        Scelerisque sit nunc, praesent blandit risus. Tortor
                        vulputate nibh ipsum amet, nam turpis volutpat facilisis
                        ornare. Orci.
                      </p>
                    </div>
                  </div>
                </Grid>
              </Grid>
            </div>
            <div className={styles.success_slider_wrapper}>
              <Grid container spacing={{ xs: 2, sm: 2, md: 4 }}>
                <Grid item xs={12} sm={12} md={6}>
                  <div className={styles.image_wrapper}>
                    <img
                      src={getAssets(
                        "assets/images/elearning/home/laptop-mockup.png"
                      )}
                      alt="laptop-mockup"
                    />
                  </div>
                </Grid>
                <Grid item xs={12} sm={12} md={6}>
                  <div className={styles.description_wrapper}>
                    <h3 className={styles.description_heading}>
                      Secure and Robust
                    </h3>
                    <div className={styles.description}>
                      <p>
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                        Ac massa enim id tincidunt eget vitae. Consequat egestas
                        amet, elit eu. Egestas placerat laoreet varius risus,
                        mauris vitae dui, amet. Nulla quam porttitor non
                        consequat, pulvinar.
                      </p>
                      <p>
                        Eu odio nam convallis velit enim volutpat. Ipsum quis
                        pulvinar vitae bibendum gravida maecenas fusce etiam.
                        Scelerisque sit nunc, praesent blandit risus. Tortor
                        vulputate nibh ipsum amet, nam turpis volutpat facilisis
                        ornare. Orci.
                      </p>
                    </div>
                  </div>
                </Grid>
              </Grid>
            </div>
          </Slider>
        </div>
      </div>
    </section>
  );
};

export default ElearningTechnologySuccess;
